import { showError } from 'src/toasts/toasts';
import { NameFormat, formatName } from 'src/utils/nameFormatting';
import { GroupMember } from '../grouping';
import { PartialSaveError } from './useSaveGroupedItem';

/**
 * A save that reached some members but not others is reported by name: the adviser has to know
 * which members still need the item, and which are still carrying one that should have gone.
 * Returns whether the error was a partial save.
 */
export function reportSaveFailure(
  error: unknown,
  memberByClientId: Map<string, GroupMember>,
  noun: string,
): boolean {
  if (!(error instanceof PartialSaveError)) return false;

  const sentences = [];
  if (error.failedSaveClientIds.length > 0) {
    sentences.push(
      `${noun} saved, but not for ${names(error.failedSaveClientIds, memberByClientId)}. Add it for them again.`,
    );
  }
  if (error.failedDeleteClientIds.length > 0) {
    sentences.push(
      `${noun} is still recorded against ${names(error.failedDeleteClientIds, memberByClientId)}. Remove it from them again.`,
    );
  }

  showError(sentences.join(' '));
  return true;
}

function names(clientIds: string[], memberByClientId: Map<string, GroupMember>): string {
  return clientIds
    .map(clientId => memberByClientId.get(clientId))
    .map(member =>
      member ? formatName(member.firstName, member.lastName, NameFormat.NATURAL) : 'a member',
    )
    .join(', ');
}
